import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Rocket, ArrowRight } from "lucide-react";

export default function ReservedPlanBanner() {
  const [st, setSt] = useState(null);
  useEffect(() => {
    api.get("/billing/sg/status").then((r) => setSt(r.data)).catch(() => setSt(null));
  }, []);
  if (!st || st.has_subscription || st.pre_launch_mode || !st.pre_launch_reserved) return null;
  const r = st.pre_launch_reservation || {};
  const plan = r.plan ? r.plan.charAt(0).toUpperCase() + r.plan.slice(1) : "";
  return (
    <div data-testid="reserved-plan-banner"
         className="pf-card mb-6 border-cyan-300 bg-gradient-to-r from-cyan-50 via-white to-white p-5 flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-cyan-600 text-white flex items-center justify-center shrink-0">
          <Rocket className="w-5 h-5" />
        </div>
        <div>
          <div className="font-display text-lg text-slate-900" data-testid="reserved-plan-banner-title">
            Your reserved plan is waiting
          </div>
          <div className="text-sm text-slate-600" data-testid="reserved-plan-banner-details">
            {plan} · {r.cadence === "annual" ? "billed annually" : "billed monthly"}
            {(r.provinces || []).length ? ` · ${r.provinces.join(", ")}` : ""}. Finish checkout to unlock it.
          </div>
        </div>
      </div>
      <Link to="/merchant/billing?complete_reservation=1" data-testid="reserved-plan-banner-cta"
            className="pf-btn-primary px-5 py-2.5 rounded-full text-sm font-semibold inline-flex items-center gap-2">
        Complete subscription <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
